import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberReferralTypeForm from '../../../components/forms/MemberReferralTypeForm';
import { useCreateMemberReferralType } from '../../../hooks/useMemberReferralTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberReferralTypeDTO } from '../../../services/apiClient';

const MemberReferralTypeCreate: React.FC = () => {
  const createMutation = useCreateMemberReferralType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Referral Types', href: '/admin/memberreferraltypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberReferralTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberreferraltypes');
    } catch (error) {
      console.error('Error creating MemberReferralType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberreferraltypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberReferralType.Edit'
    >
        <MemberReferralTypeForm
          initialValues={{} as MemberReferralTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberreferraltypes')}
        />
    </AdminLayout>
  );
};

export default MemberReferralTypeCreate;